import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { MethodologyPage } from "../components/methodology/MethodologyPage";
import { siteLangOf } from "../lib/marketing/registry";
import { methodologyHead } from "../lib/methodology/head";
import { loadMethodology, methodologyPath } from "../lib/methodology/index";
import { documentHeaders } from "../lib/seo";

/** `/<lang>/methodology`. Same 301 rule as every other localized route. */
export const Route = createFileRoute("/$lang/methodology")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = methodologyPath(lang);
    if (path !== `/${params.lang}/methodology`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, copy: await loadMethodology(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? methodologyHead(loaderData.lang, loaderData.copy) : {},
  component: LocalizedMethodology,
});

function LocalizedMethodology() {
  const { lang, copy } = Route.useLoaderData();
  return <MethodologyPage lang={lang} copy={copy} />;
}
